import React, { useState, useEffect } from "react";
import AffiliateLayout from "./layout";
import { SetBank } from "../../helpers/ListBank";
import axios from "axios";
import { END_POINT } from "../../constants/defaultValues";
// styles imported in AffiliateLayout
import { NotificationManager } from "../../components/common/react-notifications";

const Settings = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    bank_name: "",
    bank_number: "",
    bank_holder: "",
    password: "",
    new_password: "",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("affiliate_token");
        const res = await axios.get(`${END_POINT}/api/affiliate/profile`, {
          headers: { "x-auth-token": token },
        });
        if (res.status === 200) {
          const data = res.data.data || res.data;
          setFormData((prev) => ({
            ...prev,
            name: data.name || "",
            email: data.email || "",
            phone: data.phone || "",
            bank_name: data.bank_name || "",
            bank_number: data.bank_number || "",
            bank_holder: data.bank_holder || "",
          }));
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("affiliate_token");
      const res = await axios.post(
        `${END_POINT}/api/affiliate/profile`,
        formData,
        {
          headers: { "x-auth-token": token },
        }
      );
      if (res.status === 200) {
        NotificationManager.success(
          "Cập nhật thông tin thành công!",
          "Thành công",
          3000
        );
        setFormData((prev) => ({ ...prev, password: "", new_password: "" }));
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      NotificationManager.error(
        "Cập nhật thất bại. Vui lòng thử lại.",
        "Lỗi",
        3000
      );
    }
  };

  return (
    <AffiliateLayout title="Cài đặt">
      <div className="aff-page-container">
        <div className="page-header">
          <h2>Cài đặt tài khoản</h2>
          <p>
            Quản lý thông tin cá nhân và tài khoản ngân hàng nhận thanh toán.
          </p>
        </div>

        <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
          {/* Personal Info */}
          <div className="aff-card" style={{ flex: "1", minWidth: "300px" }}>
            <div className="card-header">
              <h3>Thông tin cá nhân</h3>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Họ và tên</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Email đăng nhập</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    disabled
                    className="bg-slate-50 cursor-not-allowed text-slate-500"
                  />
                  <p className="helper-text">Email không thể thay đổi</p>
                </div>
                <div className="form-group">
                  <label>Số điện thoại</label>
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                <button type="submit" className="btn-primary">
                  Lưu thay đổi
                </button>
              </form>
            </div>
          </div>

          {/* Bank Info */}
          <div className="aff-card" style={{ flex: "1", minWidth: "300px" }}>
            <div className="card-header">
              <h3>Tài khoản ngân hàng</h3>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Ngân hàng</label>
                  <select
                    name="bank_name"
                    value={formData.bank_name}
                    onChange={handleChange}
                  >
                    <option value="">-- Chọn ngân hàng --</option>
                    {SetBank.map((bank) => (
                      <option key={bank.value} value={bank.value}>
                        {bank.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Số tài khoản</label>
                  <input
                    type="text"
                    name="bank_number"
                    value={formData.bank_number}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Tên chủ tài khoản</label>
                  <input
                    type="text"
                    name="bank_holder"
                    value={formData.bank_holder}
                    onChange={handleChange}
                    className="uppercase"
                  />
                </div>
                <button type="submit" className="btn-primary">
                  Cập nhật ngân hàng
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </AffiliateLayout>
  );
};

export default Settings;
